import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col } from "reactstrap"

const Miniwidget = props => {
  const accessToken = localStorage.getItem("accessToken")

  console.log(props.reports);

  return (
    <React.Fragment>
      <Row>
        {props.reports.map((report, key) => (
          <Col xl={4} md={6} sm={12} key={key}>
            <Card className="mini-stat bg-primary">
              <CardBody className="card-body mini-stat-img d-flex align-items-center gap-3">
                <div className="mini-stat-icon ">
                  <i className={"ion" + report.iconClass}></i>
                </div>
                <div className="text-white">
                  <h6 className="text-uppercase  font-size-16 text-white">
                    {report.title}
                  </h6>
                  <h2 className="text-white">{report.total}</h2>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  )
}

export default Miniwidget
